import type { NodeId } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface DeselectAllNodesCommand {
  except?: Set<NodeId>;
}

export const deselectAllNodes: GraphCommandFactory<
  DeselectAllNodesCommand | undefined
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    if (command?.except?.size) {
      // command.except is intentionally first - we use implementation detail here
      // that the first set in the argument list is iterated and its element are looked up in other sets.
      // We expect that "except" will be significantly smaller set than all selected nodes,
      // so the lookup will likely be faster.
      draft.graph.selectedNodeIds = plainSet.intersectionAll(
        command.except,
        draft.graph.selectedNodeIds,
      );
    } else {
      draft.graph.selectedNodeIds.clear();
    }
  });
};
